import styled from 'styled-components';

import { SquaredButton } from 'ui-redesign/elements';

export const AddToCartBulkStyled = styled(SquaredButton)`
  margin-top: 0.8rem;
`;
